import FixScroll from '../helpers/FixScroll'

class Newsletter {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.body = document.body
    this.ui = {}
    this.ui.$content = document.querySelector('.js-newsletter')
    this.ui.$btn = document.querySelectorAll('.js-newsletter-btn')
    this.ui.$close = this.ui.$content.querySelector('.js-newsletter-close')
    this.ui.$form = this.ui.$content.querySelector('#mailjetSubscriptionForm')
    this.ui.$email = this.ui.$form.querySelector('#mailjet_widget_email')
    this.ui.$submit = this.ui.$form.querySelector('input[type="submit"]')
  }

  bindEvents() {
    for(let i = 0; i < this.ui.$btn.length; i++) {
      this.ui.$btn[i].addEventListener('click', this.onClick.bind(this))
    }

    this.ui.$close.addEventListener('click', this.onClose.bind(this))
    this.ui.$submit.addEventListener('click', this.onSubmit.bind(this))
  }

  onClick() {
    this.body.classList.add('newsletter-visible')
    this.ui.$content.classList.add('is-visible')
    document.body.style.overflow = 'hidden'
  }

  onClose() {
    if(this.ui.$content.classList.contains('is-visible')) {
      this.body.classList.remove('newsletter-visible')
      this.ui.$content.classList.remove('is-visible')
      document.body.style.overflow = 'inherit';
    }
  }

  onSubmit() {
    if(this.ui.$email.value == '') {
      this.ui.$email.classList.add('error')
    }

    if(this.ui.$form.parentNode.querySelector('.mailjet_widget_form_message') && this.ui.$email.value != '') {
      this.ui.$form.classList.add('u-is-hidden')
    }
  }
}

export default Newsletter
